<template>
  <div class="container">
    <TableBasic :payload="payload" />
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
export default {
  components: {
    TableBasic,
  },
  data() {
    return {
      payload: {
        header: [
          {
            key: "no_invoice",
            label: "No Invoice",
            class: "text-center",
          },
          {
            key: "corporate_code",
            label: "Corporate Code",
            class: "text-center",
          },
          {
            key: "corporate_name",
            label: "Corporate Name",
            class: "text-center",
          },
          {
            key: "order_total",
            label: "Order Total",
            class: "text-center",
          },
          {
            key: "order_date",
            label: "Order Date",
            class: "text-center",
          },
          {
            key: "action",
            label: "Action",
            class: "text-center",
          },
        ],
        value: [
          {
            no_invoice: "PMKT-123",
            corporate_code: "Cwilapa",
            corporate_name: "CW Store",
            order_total: "Rp.35.000",
            order_date: "25 Jan 2022",
            action: "",
          },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
    };
  },
};
</script>

<style></style>
